import { render, staticRenderFns } from "./travailleur-info.html?vue&type=template&id=70ef2d24&scoped=true&external"
import script from "./travailleur-info.js?vue&type=script&lang=js&external"
export * from "./travailleur-info.js?vue&type=script&lang=js&external"
import style0 from "./travailleur-info.scss?vue&type=style&index=0&id=70ef2d24&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ef2d24",
  null
  
)

export default component.exports